import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { CONTESTATION_TYPE_OPTIONS, STATUS_VALUES } from './pix-med.constants';

// `validateSearch` de `/contas-digitais/pix-med-admin` (U07). Leve de propósito: é JS inicial.
// Na URL ficam só os filtros **aplicados** (o que foi pesquisado) e `consulta=1`; o rascunho é do formulário.

/** O roteador lê `?agencyCode=0012` como texto e `?agencyCode=1234` como número: os dois voltam texto. */
const text = z
  .union([z.string(), z.number().transform(String)])
  .pipe(z.string().max(200))
  .optional()
  .catch(undefined);

const TYPES = CONTESTATION_TYPE_OPTIONS.map((option) => option.value) as ['1', '2'];

export const pixMedFilterShape = {
  contestationType: z
    .union([z.string(), z.number().transform(String)])
    .pipe(z.enum(TYPES))
    .optional()
    .catch(undefined),
  recipientName: text,
  registrationNumber: text,
  bankCode: text,
  bankName: text,
  counterpartyBankIspb: text,
  agencyCode: text,
  accountNumber: text,
  transactionId: text,
  startDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  status: z.enum(STATUS_VALUES).optional().catch(undefined),
  /** Ordem dos seletores mexidos (`contestationType`, `bank`, `status`), para o fio do legado (R3). */
  auxiliares: z
    .string()
    .regex(/^(contestationType|bank|status)(,(contestationType|bank|status)){0,2}$/)
    .optional()
    .catch(undefined),
};

export const pixMedSearch = listSearchSchema({
  ...pixMedFilterShape,
  /** A pessoa pesquisou (o `isFilter` do legado, `PixMedAdminContainer.tsx:25,44`). */
  consulta: z.coerce.number().pipe(z.literal(1)).optional().catch(undefined),
  /** Contestação aberta no painel, na URL para o voltar fechar (U26). */
  contestacao: text,
});
export type PixMedSearch = z.infer<typeof pixMedSearch>;
